import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { ModalService } from '@app/core/services/modal.service';
import { StateService } from '@app/core/services/state.service';
import { TranslateService } from '@app/core/services/translate.service';
import { UtilityService } from '@app/core/services/utility.service';
import { PurchHeadGet, PurchHeadService } from '@app/services/purch-head.service';

@Component({
    selector: 'tt-purch-head-functions',
    templateUrl: './purch-head-functions.component.html',
    styleUrls: ['./purch-head-functions.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PurchHeadFunctionsComponent {
    public get?: PurchHeadGet;

    @Output()
    public onDelete = new EventEmitter<void>();

    public convertingToPurchOrder = false;

    public deletingPurchase = false;

    constructor(
        private purchHead: PurchHeadService,
        private translate: TranslateService,
        private modal: ModalService,
        private layout: LayoutService,
        private utility: UtilityService,
        private state: StateService,
        private cdr: ChangeDetectorRef,
    ) {
        purchHead.currentPurchHead$.subscribe({
            next: (value) => {
                if (!!value) {
                    this.get = value;
                } else {
                    delete this.get;
                }

                this.cdr.markForCheck();
                setTimeout(() => this.cdr.markForCheck());
            },
        });

        this.translate.translated$.subscribe({ next: () => this.cdr.markForCheck() });
    }

    public async openEmailCreateDialog(event: MouseEvent) {
        if (!this.get) return;

        if (this.layout.getMediaQueries().tablet.matches === true) {
            this.modal.openStateDialog({ state: 'emailcreate', params: `purchhead/purch_internal_no/${this.get.purch_internal_no}` });
        } else {
            if (this.utility.isModifierKeyPressed(event)) {
                this.state.newTab('emailcreate', { webpage: 'purchhead', argtype: 'purch_internal_no', argvalue: this.get.purch_internal_no });
            } else {
                this.state.go('emailcreate', { webpage: 'purchhead', argtype: 'purch_internal_no', argvalue: this.get.purch_internal_no });
            }
        }
    }

    public async openSettings(event: MouseEvent) {
        if (!this.get) return;

        event.preventDefault();

        await this.modal.openStateDialog({ state: 'webpagesettingmenu', params: 'purchhead' }, { width: '90vw', height: '80vh' });
        this.purchHead.setPurchHeadFromParams({ purch_internal_no: +this.get.purch_internal_no });
    }

    public async convertToPurchOrder() {
        if (!this.get) return;

        try {
            this.convertingToPurchOrder = true;
            this.cdr.markForCheck();

            await this.purchHead.savePurchHead(this.get);
            await this.purchHead.convertToPurchOrder({ purch_internal_no: +this.get.purch_internal_no });
        } catch (error) {
            console.error(error);
        } finally {
            this.convertingToPurchOrder = false;
            this.cdr.markForCheck();
        }
    }

    public async deletePurchase() {
        if (!this.get) return;

        try {
            this.deletingPurchase = true;
            this.cdr.markForCheck();
            let translateConfirmMessage = false;
            let confirmMessage = await this.purchHead.getDeleteConfirmationMessage({ purch_internal_no: +this.get.purch_internal_no });

            if (!confirmMessage) {
                translateConfirmMessage = true;
                confirmMessage = 'confirm_message';
            }

            const confirmed = await this.modal.openConfirmDialog({ type: 'danger', title: 'confirm_title', translateTitle: true, message: confirmMessage, translateMessage: translateConfirmMessage });

            if (confirmed) {
                await this.purchHead.deletePurchHead({ purch_internal_no: +this.get.purch_internal_no });
                this.onDelete.emit();
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.deletingPurchase = false;
            this.cdr.markForCheck();
        }
    }
}
